import { CapacitorWifiConnect, ConnectState } from '@falconeta/capacitor-wifi-connect';

import { IS_IOS } from '../../../../../common/constants';
import { timeout } from '../../../../../utils/common/common-utils';
import { WAIT_FOR_NATIVE_WIFI_MS } from './constants';

type WifiDeviceConnectOptions = {
  ssid: string;
  password: string;
  connect?: () => Promise<ConnectState>;
  getCurrentSsid?: () => Promise<string | undefined>;
  wait?: (milliseconds: number) => Promise<unknown>;
};

export async function connectToWifiDevice({
  ssid,
  password,
  connect = async () => (await CapacitorWifiConnect.secureConnect({ ssid, password })).value,
  getCurrentSsid = async () => (await CapacitorWifiConnect.getDeviceSSID()).value,
  wait = timeout,
}: WifiDeviceConnectOptions): Promise<ConnectState> {
  const connectState = await connect();
  if (!IS_IOS) {
    if (connectState === ConnectState.Ok) {
      await wait(WAIT_FOR_NATIVE_WIFI_MS);
    }
    return connectState;
  }

  // iOS can report WifiDisabled before the joined SSID becomes available.
  await wait(WAIT_FOR_NATIVE_WIFI_MS);
  try {
    return (await getCurrentSsid()) === ssid ? ConnectState.Ok : ConnectState.Ko;
  } catch {
    return ConnectState.Ko;
  }
}
